import * as React from "react";
const SvgFiRrTachometerAltSlowest = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tachometer-alt-slowest_svg__a)">
      <path
        fill="#062147"
        d="M23.9 11.437A12 12 0 0 0 4 4.052a12.055 12.055 0 0 0-.246 17.66A4.85 4.85 0 0 0 7.114 23h9.766a5 5 0 0 0 3.508-1.429A11.94 11.94 0 0 0 23.9 11.437m-4.91 8.705a3 3 0 0 1-2.11.858H7.114a2.86 2.86 0 0 1-1.982-.74 10.044 10.044 0 0 1 .205-14.717 10 10 0 0 1 13.653 14.6M20 13a7.93 7.93 0 0 1-2.409 5.715 1 1 0 1 1-1.4-1.43C20.04 13.685 17.268 6.9 12.001 7a6.024 6.024 0 0 0-5.94 5.142 1 1 0 1 1-1.98-.284C5.766 2.13 19.731 3.113 20.001 13m-6 0a2.012 2.012 0 0 1-3.184 1.612L5.95 16.748a.998.998 0 0 1-1.428-.892 1 1 0 0 1 .628-.94l4.867-2.136A2 2 0 0 1 14 13"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tachometer-alt-slowest_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTachometerAltSlowest;
